[
  {
    "id": "actionBarSummary_click_iconButton_answerHelpful",
    "category": "AI Research",
    "action": "Interaction",
    "name": "Answer Helpful"
  },
  {
    "id": "actionBarSummary_click_iconButton_answerNotHelpful",
    "category": "AI Research",
    "action": "Interaction",
    "name": "Answer Not Helpful"
  },
  {
    "id": "actionBarSummary_click_iconButton_clickCitation",
    "category": "AI Research",
    "action": "Interaction",
    "name": "Click Citation"
  },
  {
    "id": "actionBarSummary_click_iconButton_copySummary",
    "category": "AI Research",
    "action": "Interaction",
    "name": "Copy Summary"
  },
  {
    "id": "actionBarSummary_click_iconButton_giveFeedback",
    "category": "AI Research",
    "action": "Interaction",
    "name": "Give Feedback"
  },
  {
    "id": "actionBarSummary_click_iconButton_answerNotHelpfulFeedback",
    "category": "AI Research",
    "action": "Interaction",
    "name": "Answer Not Helpful Feedback"
  },
  {
    "id": "actionBarSummary_click_iconButton_answerNotHelpfulCloseFeedbackInput",
    "category": "AI Research",
    "action": "Interaction",
    "name": "Answer Not Helpful Close Feedback Iput"
  },
  {
    "id": "resultItem_click_iconButton_answerHelpful",
    "category": "AI Research",
    "action": "Interaction",
    "name": "Answer Helpful"
  },
  {
    "id": "resultItem_click_iconButton_answerNotHelpful",
    "category": "AI Research",
    "action": "Interaction",
    "name": "Answer Not Helpful"
  },
  {
    "id": "summary_click_textButton_backToStart",
    "category": "AI Research",
    "action": "Navigate",
    "name": "Back to Start"
  },
  {
    "id": "searchInput_click_iconButton_search",
    "category": "AI Research",
    "action": "Search",
    "name": "Submit Search"
  },
  {
    "id": "searchInput_click_toggleButton_preferRecentContent",
    "category": "AI Research",
    "action": "Search",
    "name": "Prefer Recent content"
  },
  {
    "id": "searchInput_keydown_input_search",
    "category": "AI Research",
    "action": "Search",
    "name": "Submit Search"
  },
  {
    "id": "searchInputSummary_click_iconButton_search",
    "category": "AI Research",
    "action": "Search",
    "name": "Submit Search"
  },
  {
    "id": "searchInputSummary_click_toggleButton_preferRecentContent",
    "category": "AI Research",
    "action": "Search",
    "name": "Prefer Recent content"
  },
  {
    "id": "searchInputSummary_keydown_input_search",
    "category": "AI Research",
    "action": "Search",
    "name": "Submit Search"
  },
  {
    "id": "resultItem_click_iconButton_close",
    "category": "AI Research",
    "action": "Sources",
    "name": "Close Result Item"
  },
  {
    "id": "resultList_click_teaser_resultItem",
    "category": "AI Research",
    "action": "Sources",
    "name": "Open Result Item"
  },
  {
    "id": "suggestions_click_textButton_clickSuggestion",
    "category": "AI Research",
    "action": "Use Suggestions",
    "name": "Open Suggestion"
  },
  {
    "id": "suggestions_click_textButton_clickSuggestionCategory",
    "category": "AI Research",
    "action": "Use Suggestions",
    "name": "Open Suggestion Category"
  },
  {
    "id": "leftNavigationBar_click_button_changeDate",
    "category": "Archiv",
    "action": "Datepicker",
    "name": "Change Date"
  },
  {
    "id": "leftNavigationBar_click_button_resetDatepicker",
    "category": "Archiv",
    "action": "Datepicker",
    "name": "Reset Datepicker"
  },
  {
    "id": "leftNavigationBar_click_filterButton_closeDatepicker",
    "category": "Archiv",
    "action": "Datepicker",
    "name": "Close Datepicker"
  },
  {
    "id": "leftNavigationBar_click_filterButton_openDatepicker",
    "category": "Archiv",
    "action": "Datepicker",
    "name": "Open Datepicker"
  },
  {
    "id": "listView_click_filterButton_downloadMultiselect",
    "category": "Archiv",
    "action": "Multiselect",
    "name": "Download Multiselect"
  },
  {
    "id": "listView_click_textButton_downloadMultiselect",
    "category": "Archiv",
    "action": "Multiselect",
    "name": "Download Multiselect"
  },
  {
    "id": "listView_click_iconButton_closeMultiselect",
    "category": "Archiv",
    "action": "Multiselect",
    "name": "Download Multiselect"
  },
  {
    "id": "iconButtons_click_iconButton_closeFeedDetail",
    "category": "Archiv",
    "action": "FeedDetail",
    "name": "Close feedDetail"
  },
  {
    "id": "iconButtons_click_iconButton_openDetailInNewTab",
    "category": "Archiv",
    "action": "FeedDetail",
    "name": "Open Detail in New Tab"
  },
  {
    "id": "filter_click_checkbox_selectFilter",
    "category": "Archiv",
    "action": "Filter",
    "name": "Select Filter"
  },
  {
    "id": "filter_click_filterButton_openFilter",
    "category": "Archiv",
    "action": "Filter",
    "name": "Open Dropdown"
  },
  {
    "id": "filter_click_popover_closeFilter",
    "category": "Archiv",
    "action": "Filter",
    "name": "Close Filter"
  },
  {
    "id": "filter_click_textButton_reset",
    "category": "Archiv",
    "action": "Filter",
    "name": "Reset Filter selection"
  },
  {
    "id": "filter_click_button_openFilterMenu",
    "category": "Archiv",
    "action": "Filter ",
    "name": "Open Filter Mobile"
  },
  {
    "id": "listView_click_filterButton_bookmarkMultiselect",
    "category": "Archiv",
    "action": "Interaction",
    "name": "Bookmark Multiselect"
  },
  {
    "id": "listView_click_filterButton_shareMultiselect",
    "category": "Archiv",
    "action": "Interaction",
    "name": "Share Multiselect"
  },
  {
    "id": "listView_click_iconButton_addBookmark",
    "category": "Archiv",
    "action": "Interaction",
    "name": "Bookmark"
  },
  {
    "id": "listView_click_iconButton_removeBookmark",
    "category": "Archiv",
    "action": "Interaction",
    "name": "Remove Bookmark "
  },
  {
    "id": "actionBar_click_textButton_openOptions",
    "category": "Archiv",
    "action": "Modify List View",
    "name": "Open Option Menu"
  },
  {
    "id": "actionBar_click_textButton_openSavedSearchMenu",
    "category": "Archiv",
    "action": "Modify List View",
    "name": "Open Saved Search Menu"
  },
  {
    "id": "listView_click_button_jumpToNewItems",
    "category": "Archiv",
    "action": "Modify List View",
    "name": "Jump To New Items"
  },
  {
    "id": "listView_click_button_loadMore",
    "category": "Archiv",
    "action": "Modify List View",
    "name": "Load more"
  },
  {
    "id": "listView_click_clickaway_sortingClose",
    "category": "Archiv",
    "action": "Modify List View",
    "name": "Sort: Close Dropdown"
  },
  {
    "id": "listView_click_filterButton_sorting",
    "category": "Archiv",
    "action": "Modify List View",
    "name": "Sort: Open Dropdown"
  },
  {
    "id": "listView_click_iconButton_changeView",
    "category": "Archiv",
    "action": "Modify List View",
    "name": "Change View"
  },
  {
    "id": "listView_click_iconButton_closeJumpToNewItemsButton",
    "category": "Archiv",
    "action": "Modify List View",
    "name": "Close Jump To New Items Button"
  },
  {
    "id": "listView_click_iconButton_compactView",
    "category": "Archiv",
    "action": "Modify List View",
    "name": "Change to Compact View"
  },
  {
    "id": "listView_click_iconButton_standardView",
    "category": "Archiv",
    "action": "Modify List View",
    "name": "Change to Standard View"
  },
  {
    "id": "listView_click_listItem_sorting",
    "category": "Archiv",
    "action": "Modify List View",
    "name": "Sort: Select Sorting"
  },
  {
    "id": "listView_click_toggleButton_autoRefresh",
    "category": "Archiv",
    "action": "Modify List View",
    "name": "Auto-Refresh"
  },
  {
    "id": "listView_scroll_none_loadMore",
    "category": "Archiv",
    "action": "Modify List View",
    "name": "Load more"
  },
  {
    "id": "optionMenu_click_popover_close",
    "category": "Archiv",
    "action": "Modify List View",
    "name": "Close Option Menu"
  },
  {
    "id": "optionMenu_click_radioButton_changeView",
    "category": "Archiv",
    "action": "Modify List View",
    "name": "Change View"
  },
  {
    "id": "optionMenu_click_radioButton_sorting",
    "category": "Archiv",
    "action": "Modify List View",
    "name": "Select Sorting"
  },
  {
    "id": "optionMenu_click_toggleButton_autoRefresh",
    "category": "Archiv",
    "action": "Modify List View",
    "name": "Auto-Refresh"
  },
  {
    "id": "optionMenuMobile_scroll_iconButton_close",
    "category": "Archiv",
    "action": "Modify List View",
    "name": "Close Option Menu"
  },
  {
    "id": "listView_click_teaser_openDetails",
    "category": "Archiv",
    "action": "Navigate",
    "name": "Open Content Item"
  },
  {
    "id": "listView_click_teaser_openDetailsAPnewsService",
    "category": "Archiv",
    "action": "Navigate",
    "name": "Open Content Item"
  },
  {
    "id": "listView_click_teaser_openDetailsAPphotostream",
    "category": "Archiv",
    "action": "Navigate",
    "name": "Open Content Item"
  },
  {
    "id": "listView_click_teaser_openDetailsAPweltnachrichten",
    "category": "Archiv",
    "action": "Navigate",
    "name": "Open Content Item"
  },
  {
    "id": "listView_click_teaser_openDetailsXinhua",
    "category": "Archiv",
    "action": "Navigate",
    "name": "Open Content Item"
  },
  {
    "id": "actionBar_click_button_save",
    "category": "Archiv",
    "action": "Save Search",
    "name": "Start Save Search"
  },
  {
    "id": "leftNavigationBar_click_button_reset",
    "category": "Archiv",
    "action": "Save Search",
    "name": "Reset Filter selection"
  },
  {
    "id": "leftNavigationBar_click_button_search",
    "category": "Archiv",
    "action": "Save Search",
    "name": "Open Saved Search"
  },
  {
    "id": "saveSearch:modal_click_button_cancel",
    "category": "Archiv",
    "action": "Save Search",
    "name": "Quit Modal"
  },
  {
    "id": "saveSearch:modal_click_button_submit",
    "category": "Archiv",
    "action": "Save Search",
    "name": "Apply"
  },
  {
    "id": "saveSearch:modal_click_colorPicker_colorPicker",
    "category": "Archiv",
    "action": "Save Search",
    "name": "Select Color"
  },
  {
    "id": "saveSearch:modal_click_iconButton_close",
    "category": "Archiv",
    "action": "Save Search",
    "name": "Quit Modal"
  },
  {
    "id": "saveSearch:modal_click_toggleButton_notifyByEMail",
    "category": "Archiv",
    "action": "Save Search",
    "name": "Notify by E-Mail"
  },
  {
    "id": "saveSearch:modal_click_toggleButton_notifyByIDApp",
    "category": "Archiv",
    "action": "Save Search",
    "name": "Notify by ID-App"
  },
  {
    "id": "saveSearch:modal_keydown_input_submit",
    "category": "Archiv",
    "action": "Save Search",
    "name": "Apply"
  },
  {
    "id": "actionBar_click_textButton_openSavedSearch",
    "category": "Archiv",
    "action": "Saved Search",
    "name": "Open Saved Search"
  },
  {
    "id": "deleteSaveSearch:modal_click_button_cancel",
    "category": "Archiv",
    "action": "Saved Search",
    "name": "Quit Modal"
  },
  {
    "id": "deleteSaveSearch:modal_click_button_submit",
    "category": "Archiv",
    "action": "Saved Search",
    "name": "Apply"
  },
  {
    "id": "deleteSaveSearch:modal_click_iconButton-clickaway-escape_close",
    "category": "Archiv",
    "action": "Saved Search",
    "name": "Quit Modal"
  },
  {
    "id": "deleteSaveSearch:modal_keydown_input_submit",
    "category": "Archiv",
    "action": "Saved Search",
    "name": "Apply"
  },
  {
    "id": "notifySavedSearch:modal_click_button_cancel",
    "category": "Archiv",
    "action": "Saved Search",
    "name": "Quit Modal"
  },
  {
    "id": "notifySavedSearch:modal_click_button_submit",
    "category": "Archiv",
    "action": "Saved Search",
    "name": "Apply"
  },
  {
    "id": "notifySavedSearch:modal_click_iconButton-clickaway-escape_close",
    "category": "Archiv",
    "action": "Saved Search",
    "name": "Quit Modal"
  },
  {
    "id": "notifySavedSearch:modal_click_toggleButton_notifyByEMail",
    "category": "Archiv",
    "action": "Saved Search",
    "name": "Notify by E-Mail"
  },
  {
    "id": "notifySavedSearch:modal_click_toggleButton_notifyByIDApp",
    "category": "Archiv",
    "action": "Saved Search",
    "name": "Notify by ID-App"
  },
  {
    "id": "notifySavedSearch:modal_keydown_input_submit",
    "category": "Archiv",
    "action": "Saved Search",
    "name": "Apply"
  },
  {
    "id": "renameSavedSearch:modal_click_button_cancel",
    "category": "Archiv",
    "action": "Saved Search",
    "name": "Quit Modal"
  },
  {
    "id": "renameSavedSearch:modal_click_button_submit",
    "category": "Archiv",
    "action": "Saved Search",
    "name": "Apply"
  },
  {
    "id": "renameSavedSearch:modal_click_colorPicker_colorPicker",
    "category": "Archiv",
    "action": "Saved Search",
    "name": "Select Color"
  },
  {
    "id": "renameSavedSearch:modal_click_iconButton-clickaway-escape_close",
    "category": "Archiv",
    "action": "Saved Search",
    "name": "Quit Modal"
  },
  {
    "id": "renameSavedSearch:modal_keydown_input_submit",
    "category": "Archiv",
    "action": "Saved Search",
    "name": "Apply"
  },
  {
    "id": "savedSearch_click_popover_closeSavedSearchMenu",
    "category": "Archiv",
    "action": "Saved Search",
    "name": "Close Saved Search Menu"
  },
  {
    "id": "savedSearch_click_textButton_openSavedSearchMenu",
    "category": "Archiv",
    "action": "Saved Search",
    "name": "Open Saved Search Menu"
  },
  {
    "id": "saveSearch:moreMenu_click_iconButton_openMoreMenu",
    "category": "Archiv",
    "action": "Saved Search",
    "name": "Open More Menu"
  },
  {
    "id": "saveSearch:moreMenu_click_listItem_selectMoreMenu",
    "category": "Archiv",
    "action": "Saved Search",
    "name": "Select from More Menu"
  },
  {
    "id": "search:modal_click_button_cancel",
    "category": "Archiv",
    "action": "Search",
    "name": "Quit Modal"
  },
  {
    "id": "search:modal_click_button_submit",
    "category": "Archiv",
    "action": "Search",
    "name": "Apply"
  },
  {
    "id": "search:modal_click_checkbox_filter",
    "category": "Archiv",
    "action": "Search",
    "name": "Select Text Field"
  },
  {
    "id": "search:modal_click_iconButton-clickaway-escape_close",
    "category": "Archiv",
    "action": "Search",
    "name": "Quit Modal"
  },
  {
    "id": "search:modal_keydown_input_submit",
    "category": "Archiv",
    "action": "Search",
    "name": "Apply"
  },
  {
    "id": "searchBar_click_button_advancedSearch",
    "category": "Archiv",
    "action": "Search",
    "name": "Open Advanced Search"
  },
  {
    "id": "searchBar_click_chip_clickChip",
    "category": "Archiv",
    "action": "Search",
    "name": "Click Chip"
  },
  {
    "id": "searchBar_click_chip_deleteChip",
    "category": "Archiv",
    "action": "Search",
    "name": "Delete Chip"
  },
  {
    "id": "searchBar_click_iconButton_reset",
    "category": "Archiv",
    "action": "Search",
    "name": "Reset Search"
  },
  {
    "id": "searchBar_click_iconButton_search",
    "category": "Archiv",
    "action": "Search",
    "name": "Submit Search"
  },
  {
    "id": "searchBar_click_iconButton_searchWordsIn",
    "category": "Archiv",
    "action": "Search",
    "name": "Search Words In"
  },
  {
    "id": "searchBar_keydown_input_search",
    "category": "Archiv",
    "action": "Search",
    "name": "Submit Search"
  },
  {
    "id": "searchBar_mouseOver_iconButton_hoverSearchTips",
    "category": "Archiv",
    "action": "Search",
    "name": "Hover Search Tips"
  },
  {
    "id": "endOfList_click_textButton_removeDefaultFilter",
    "category": "Archiv",
    "action": "Filter ",
    "name": "Remove Default Filter"
  },
  {
    "id": "detailpage_click_iconButton_submitAnswer",
    "category": "Archiv Detailpage",
    "action": "Answer Comment",
    "name": "Submit Answer"
  },
  {
    "id": "detailpage_click_textButton_answerMessage",
    "category": "Archiv Detailpage",
    "action": "Answer Comment",
    "name": "Answer Message"
  },
  {
    "id": "detailpage_click_textButton_closeAnswerMessage",
    "category": "Archiv Detailpage",
    "action": "Answer Comment",
    "name": "Close Answer Message"
  },
  {
    "id": "detailpage_click_button_download",
    "category": "Archiv Detailpage",
    "action": "Download",
    "name": "Download"
  },
  {
    "id": "detailpage_click_filterButton_openFilter",
    "category": "Archiv Detailpage",
    "action": "Download",
    "name": "Open Dropdown"
  },
  {
    "id": "detailpage_click_listItem_download_file",
    "category": "Archiv Detailpage",
    "action": "Download",
    "name": "Download File"
  },
  {
    "id": "actionBar_click_iconButton_addBookmark",
    "category": "Archiv Detailpage",
    "action": "Interaction",
    "name": "Bookmark"
  },
  {
    "id": "actionBar_click_iconButton_copyText",
    "category": "Archiv Detailpage",
    "action": "Interaction",
    "name": "Copy Text"
  },
  {
    "id": "actionBar_click_iconButton_jumpToComment",
    "category": "Archiv Detailpage",
    "action": "Interaction",
    "name": "Jump to Comment"
  },
  {
    "id": "actionBar_click_iconButton_removeBookmark",
    "category": "Archiv Detailpage",
    "action": "Interaction",
    "name": "Remove Bookmark "
  },
  {
    "id": "actionBar_click_iconButton_share",
    "category": "Archiv Detailpage",
    "action": "Interaction",
    "name": "Share"
  },
  {
    "id": "caption_click_iconButton_copyText",
    "category": "Archiv Detailpage",
    "action": "Interaction",
    "name": "Copy Text"
  },
  {
    "id": "transcription_click_iconButton_copyText",
    "category": "Archiv Detailpage",
    "action": "Interaction",
    "name": "Copy Text"
  },
  {
    "id": "relatedContent_click_teaser_relatedContent",
    "category": "Archiv Detailpage",
    "action": "RelatedContent",
    "name": "Open Related Content Item"
  },
  {
    "id": "relatedContentNavigation_click_textButton_switchRelatedContent",
    "category": "Archiv Detailpage",
    "action": "RelatedContent",
    "name": "Switch Related Content View"
  },
  {
    "id": "relatedContentPictureAlliance_click_teaser_relatedContentPictureAlliance",
    "category": "Archiv Detailpage",
    "action": "RelatedContent",
    "name": "Open Related Content Item"
  },
  {
    "id": "relatedContentPictureAlliance_click_textButton_relatedContentOverviewPictureAlliance",
    "category": "Archiv Detailpage",
    "action": "RelatedContent",
    "name": "Open Related Content Overview"
  },
  {
    "id": "detailpage_click_iconButton_submitComment",
    "category": "Archiv Detailpage",
    "action": "Submit Comment",
    "name": "Submit initial Message"
  },
  {
    "id": "Bookmarks_click_textButton_clearBookmarkList",
    "category": "Bookmark",
    "action": "Clear Bookmark List",
    "name": "Clear Bookmark List"
  },
  {
    "id": "Bookmarks_click_button_loadMoreBookmark",
    "category": "Bookmark",
    "action": "Modify List View Bookmarks",
    "name": "Load more"
  },
  {
    "id": "Bookmarks_click_clickaway_sortingCloseBoookmark",
    "category": "Bookmark",
    "action": "Modify List View Bookmarks",
    "name": "Sort: Close Dropdown"
  },
  {
    "id": "Bookmarks_click_filterButton_sortingBookmark",
    "category": "Bookmark",
    "action": "Modify List View Bookmarks",
    "name": "Sort: Open Dropdown"
  },
  {
    "id": "Bookmarks_click_iconButton_changeViewBookmark",
    "category": "Bookmark",
    "action": "Modify List View Bookmarks",
    "name": "Change View"
  },
  {
    "id": "Bookmarks_click_iconButton_compactViewBookmark",
    "category": "Bookmark",
    "action": "Modify List View Bookmarks",
    "name": "Change to Compact View"
  },
  {
    "id": "Bookmarks_click_iconButton_standardViewBookmark",
    "category": "Bookmark",
    "action": "Modify List View Bookmarks",
    "name": "Change to Standard View"
  },
  {
    "id": "Bookmarks_click_listItem_sortingBookmark",
    "category": "Bookmark",
    "action": "Modify List View Bookmarks",
    "name": "Sort: Select Sorting"
  },
  {
    "id": "Bookmarks_scroll_none_loadMoreBookmark",
    "category": "Bookmark",
    "action": "Modify List View Bookmarks",
    "name": "Load more"
  },
  {
    "id": "Bookmarks_click_iconButton_removeBookmark",
    "category": "Bookmark",
    "action": "Remove Bookmark",
    "name": "Remove Bookmark"
  },
  {
    "id": "Bookmarks_click_textButton_removeAllUnauthorizedBookmarks",
    "category": "Bookmark",
    "action": "Remove Bookmark",
    "name": "Remove All Unauthorized Bookmarks"
  },
  {
    "id": "Bookmarks_click_textButton_removeUnauthorizedBookmark",
    "category": "Bookmark",
    "action": "Remove Bookmark",
    "name": "Remove Unauthorized Bookmark "
  },
  {
    "id": "detailpageCvd_click_iconButton_submitAnswer",
    "category": "CvD",
    "action": "Answer Comment",
    "name": "Submit Answer"
  },
  {
    "id": "detailpageCvd_click_textButton_answerMessage",
    "category": "CvD",
    "action": "Answer Comment",
    "name": "Answer Message"
  },
  {
    "id": "detailpageCvd_click_textButton_closeAnswerMessage",
    "category": "CvD",
    "action": "Answer Comment",
    "name": "Close Answer Message"
  },
  {
    "id": "newspackage_click_iconButton_submitAnswer",
    "category": "CvD",
    "action": "Answer Comment",
    "name": "Submit Answer"
  },
  {
    "id": "newspackage_click_textButton_answerMessage",
    "category": "CvD",
    "action": "Answer Comment",
    "name": "Answer Message"
  },
  {
    "id": "newspackage_click_textButton_closeAnswerMessage",
    "category": "CvD",
    "action": "Answer Comment",
    "name": "Close Answer Message"
  },
  {
    "id": "enquiryBox_click_iconButton_closeEnquiryBox",
    "category": "CvD",
    "action": "Close Enquiry Box",
    "name": "Close Enquiry Box"
  },
  {
    "id": "newspackage_click_textButton_hideComments",
    "category": "CvD",
    "action": "Hide Comments",
    "name": "Hide Newspackage Comments"
  },
  {
    "id": "enquiryBox_click_textButton_goToEnquiries",
    "category": "CvD",
    "action": "Navigate",
    "name": "See All Enquiries in Messenger"
  },
  {
    "id": "enquiryBox_click_textButton_goToSentEnquiry",
    "category": "CvD",
    "action": "Navigate",
    "name": "See sent Enquiry in Messenger"
  },
  {
    "id": "enquiryBox_click_textButton_sendNewEnquiry",
    "category": "CvD",
    "action": "Navigate",
    "name": "Send new Enquiry"
  },
  {
    "id": "gallery_click_contentTeaser_openImage",
    "category": "CvD",
    "action": "Navigate",
    "name": "Open Image from Picture Slider"
  },
  {
    "id": "pictureSlider_click_contentTeaser_openImage",
    "category": "CvD",
    "action": "Navigate",
    "name": "Open Image from Picture Slider"
  },
  {
    "id": "pictureSlider_click_textButton_openGallery",
    "category": "CvD",
    "action": "Navigate",
    "name": "Open Gallery from Picture Slider"
  },
  {
    "id": "categoryNavigation_click_iconButton_showMoreNavigation",
    "category": "CvD",
    "action": "Navigate CvD",
    "name": "Show More CvD category navigation"
  },
  {
    "id": "categoryNavigation_click_textButton_navlink",
    "category": "CvD",
    "action": "Navigate CvD",
    "name": "Open new CvD category"
  },
  {
    "id": "categoryNavigation_click_textButton_navlinkPriorityPlus",
    "category": "CvD",
    "action": "Navigate CvD",
    "name": "Open new CvD category"
  },
  {
    "id": "topicNavigation_click_iconButton_showMoreTopicNavigation",
    "category": "CvD",
    "action": "Navigate CvD",
    "name": "Show More CvD topic navigation"
  },
  {
    "id": "topicNavigation_click_textButton_anchorLink",
    "category": "CvD",
    "action": "Navigate CvD",
    "name": "Jump to Newspackage"
  },
  {
    "id": "topicNavigation_click_textButton_anchorLinkPriorityPlus",
    "category": "CvD",
    "action": "Navigate CvD",
    "name": "Jump to Newspackage"
  },
  {
    "id": "newspackage_click_iconButton_openDetailInNewTab",
    "category": "CvD",
    "action": "Navigate Newspackage",
    "name": "Open Detail in New Tab"
  },
  {
    "id": "newspackageAccordeon_click_textButton_closeAccordeon",
    "category": "CvD",
    "action": "Navigate Newspackage",
    "name": "Show less"
  },
  {
    "id": "newspackageAccordeon_click_textButton_openAccordeon",
    "category": "CvD",
    "action": "Navigate Newspackage",
    "name": "Show more"
  },
  {
    "id": "newspackageMediatypeNavigation_click_textButton_tabLink",
    "category": "CvD",
    "action": "Navigate Newspackage",
    "name": "Open Newspackage Mediatype Tab"
  },
  {
    "id": "newspackageMediatypeTab_click_contentTeaser_openContentMediatypeTab",
    "category": "CvD",
    "action": "Navigate Newspackage",
    "name": "Open Content Item Mediatype Tab"
  },
  {
    "id": "topicRadar_click_textButton_topicRadarLink",
    "category": "CvD",
    "action": "Navigate Topic Radar",
    "name": "Open Topic Radar Link"
  },
  {
    "id": "driveFeature_click_textButton_driveFeatureLink",
    "category": "CvD",
    "action": "Navigate DRIVE Feature",
    "name": "Open DRIVE FeatureLink"
  },
  {
    "id": "enquiryBox_click_iconButton_openEnquiryBox",
    "category": "CvD",
    "action": "Open Enquiry Box",
    "name": "Open Enquiry Box"
  },
  {
    "id": "cvdAufmacherRadar_click_iconButton_readTooltip",
    "category": "CvD",
    "action": "Read Tooltip",
    "name": "Read Tooltip"
  },
  {
    "id": "cvdDRIVE_click_iconButton_readTooltip",
    "category": "CvD",
    "action": "Read Tooltip",
    "name": "Read Tooltip"
  },
  {
    "id": "newspackage_click_textButton_showComments",
    "category": "CvD",
    "action": "Show Comments",
    "name": "Show Newspackage Comments"
  },
  {
    "id": "detailpageCvd_click_iconButton_submitComment",
    "category": "CvD",
    "action": "Submit Comment",
    "name": "Submit initial Message"
  },
  {
    "id": "newspackage_click_iconButton_submitComment",
    "category": "CvD",
    "action": "Submit Comment",
    "name": "Submit initial Message"
  },
  {
    "id": "enquiryBox_click_iconButton_submitInitialMessage",
    "category": "CvD",
    "action": "Submit Enquiry",
    "name": "Submit initial Message"
  },
  {
    "id": "newspackageMediatypeNavigationDetailpage_click_textButton_tabLink",
    "category": "CvD Detailpage",
    "action": "Navigate CvD Detailpage Newspackage",
    "name": "Open Newspackage Mediatype Tab"
  },
  {
    "id": "newspackageMediatypeTabDetailpage_click_contentTeaser_openContentMediatypeTab",
    "category": "CvD Detailpage",
    "action": "Navigate CvD Detailpage Newspackage",
    "name": "Open Content Item Mediatype Tab"
  },
  {
    "id": "deskSettings_click_button_addWidget",
    "category": "Desk",
    "action": "Add Widget",
    "name": "Add Widget"
  },
  {
    "id": "widgetSelection_click_button_selectWidgetBackToWidget",
    "category": "Desk",
    "action": "Configure Widget",
    "name": "Back To First Layer"
  },
  {
    "id": "widgetSelection_click_listItem_selectWidgetConfiguration",
    "category": "Desk",
    "action": "Configure Widget",
    "name": "Select Widget Configuration"
  },
  {
    "id": "widgetSelection_click_listItem_selectWidgetOpenSecondLayer",
    "category": "Desk",
    "action": "Configure Widget",
    "name": "Open Second Layer"
  },
  {
    "id": "widgetSelection_click_button_quitSecondLayer",
    "category": "Desk",
    "action": "Configure Widget",
    "name": "Quit Second Layer"
  },
  {
    "id": "deskNavigation_click_button_createOpen",
    "category": "Desk",
    "action": "Create New Desk",
    "name": "Create New Desk"
  },
  {
    "id": "deskSettings:modal_click_button_create_cancel",
    "category": "Desk",
    "action": "Create New Desk",
    "name": "Quit Modal"
  },
  {
    "id": "deskSettings:modal_click_button_create_submit",
    "category": "Desk",
    "action": "Create New Desk",
    "name": "Apply"
  },
  {
    "id": "deskSettings:modal_click_iconButton-clickaway-escape_create_close",
    "category": "Desk",
    "action": "Create New Desk",
    "name": "Quit Modal"
  },
  {
    "id": "deskSettings_click_iconButton_intentToDeleteDesk",
    "category": "Desk",
    "action": "Delete Desk",
    "name": "Delete Desk"
  },
  {
    "id": "deskSettings:modal_click_button_delete_cancel",
    "category": "Desk",
    "action": "Delete Desk",
    "name": "Quit Modal"
  },
  {
    "id": "deskSettings:modal_click_button_delete_submit",
    "category": "Desk",
    "action": "Delete Desk",
    "name": "Apply"
  },
  {
    "id": "deskSettings_click_iconButton_intentToShareDesk",
    "category": "Desk",
    "action": "Desk Sharing",
    "name": "Share Desk"
  },
  {
    "id": "shareDesk:modal_click_button_shareDeskSubmit",
    "category": "Desk",
    "action": "Desk Sharing",
    "name": "Share Desk Copy Link"
  },
  {
    "id": "shareDeskStop:modal_click_button_cancel",
    "category": "Desk",
    "action": "Desk Sharing",
    "name": "Quit Modal"
  },
  {
    "id": "shareDeskStop:modal_click_button_submit",
    "category": "Desk",
    "action": "Desk Sharing",
    "name": "Apply"
  },
  {
    "id": "shareDeskStop:modal_click_iconButton-clickaway-escape_close",
    "category": "Desk",
    "action": "Desk Sharing",
    "name": "Quit Modal"
  },
  {
    "id": "deskSettings_click_iconButton_intentToEditDesk",
    "category": "Desk",
    "action": "Edit",
    "name": "Edit Desk"
  },
  {
    "id": "widget_click_moveCursor_relocateWidget",
    "category": "Desk",
    "action": "Edit Widget",
    "name": "Relocate Widget"
  },
  {
    "id": "widget_click_resizePointer_resizeWidget",
    "category": "Desk",
    "action": "Edit Widget",
    "name": "Resize Widget"
  },
  {
    "id": "widget:moreMenu_click_clickaway_moreMenuClickaway",
    "category": "Desk",
    "action": "Edit Widget",
    "name": "Close More Menu"
  },
  {
    "id": "widget:moreMenu_click_iconButton_openMoreMenu",
    "category": "Desk",
    "action": "Edit Widget",
    "name": "Open More Menu"
  },
  {
    "id": "widget:moreMenu_click_listItem_selectItem",
    "category": "Desk",
    "action": "Edit Widget",
    "name": "Select from More Menu"
  },
  {
    "id": "widget:moreMenu_click_radioButton_changeView",
    "category": "Desk",
    "action": "Edit Widget",
    "name": "Change View"
  },
  {
    "id": "widget_click_button_toAllResults",
    "category": "Desk",
    "action": "Navigate",
    "name": "To All Results"
  },
  {
    "id": "deskNavigation_click_button_openDesk",
    "category": "Desk",
    "action": "Navigate",
    "name": "Open Desk"
  },
  {
    "id": "widget_click_teaser_widgetCommentTeaser",
    "category": "Desk",
    "action": "Navigate",
    "name": "Open Content Item"
  },
  {
    "id": "widget_click_teaser_widgetCountryTeaser",
    "category": "Desk",
    "action": "Navigate",
    "name": "Open Content Item"
  },
  {
    "id": "widget_click_teaser_widgetEnquiryTeaser",
    "category": "Desk",
    "action": "Navigate",
    "name": "Open Content Item"
  },
  {
    "id": "widget_click_teaser_widgetFeedTeaser",
    "category": "Desk",
    "action": "Navigate",
    "name": "Open Content Item"
  },
  {
    "id": "widget_click_teaser_widgetPictureTeaser",
    "category": "Desk",
    "action": "Navigate",
    "name": "Open Content Item"
  },
  {
    "id": "widget_click_teaser_widgetSearchTeaser",
    "category": "Desk",
    "action": "Navigate",
    "name": "Open Content Item"
  },
  {
    "id": "widget_click_teaser_widgetUrgencyTeaser",
    "category": "Desk",
    "action": "Navigate",
    "name": "Open Content Item"
  },
  {
    "id": "topicRadar_click_textButton_topicRadarLinkWidget",
    "category": "Desk",
    "action": "Navigate Topic Radar",
    "name": "Open Topic Radar Link"
  },
  {
    "id": "driveFeature_click_textButton_driveFeatureLinkWidget",
    "category": "Desk",
    "action": "Navigate DRIVE Feature",
    "name": "Open DRIVE FeatureLink"
  },
  {
    "id": "deskSettings:modal_click_button_rename_cancel",
    "category": "Desk",
    "action": "Rename Desk",
    "name": "Quit Modal"
  },
  {
    "id": "deskSettings:modal_click_button_rename_submit",
    "category": "Desk",
    "action": "Rename Desk",
    "name": "Apply"
  },
  {
    "id": "deskSettings:modal_click_iconButton-clickaway-escape_rename_close",
    "category": "Desk",
    "action": "Rename Desk",
    "name": "Quit Modal"
  },
  {
    "id": "header_click_listItem_changeLanguage",
    "category": "Global",
    "action": "Change Language",
    "name": "Change Language"
  },
  {
    "id": "footer_click_textButton_footerlink",
    "category": "Global",
    "action": "Navigate",
    "name": "Navigate to footer Link"
  },
  {
    "id": "header_click_button_feedback",
    "category": "Global",
    "action": "Navigate",
    "name": "Open Feedback"
  },
  {
    "id": "header_click_button_idavatar",
    "category": "Global",
    "action": "Navigate",
    "name": "Open ID Avatar"
  },
  {
    "id": "header_click_iconButton_appswitcher",
    "category": "Global",
    "action": "Navigate",
    "name": "Open AppSwitcher"
  },
  {
    "id": "header_click_iconButton_bookmarks",
    "category": "Global",
    "action": "Navigate",
    "name": "Open Bookmarks"
  },
  {
    "id": "header_click_iconButton_settingsPage",
    "category": "Global",
    "action": "Navigate",
    "name": "Open Settings Page"
  },
  {
    "id": "header_click_textButton_home",
    "category": "Global",
    "action": "Navigate",
    "name": "Navigate to Home"
  },
  {
    "id": "header_click_textButton_navlink",
    "category": "Global",
    "action": "Navigate",
    "name": "Navigate to other News Area"
  },
  {
    "id": "mobileNavigation_click_button_feedback",
    "category": "Global",
    "action": "Navigate",
    "name": "Open Feedback"
  },
  {
    "id": "mobileNavigation_click_iconButton_toggleMobileNavigation",
    "category": "Global",
    "action": "Navigate",
    "name": "Toggle Mobile Navigation"
  },
  {
    "id": "mobileNavigation_click_textButton_navlink",
    "category": "Global",
    "action": "Navigate",
    "name": "Navigate to other News Area"
  },
  {
    "id": "onboardingModal_click_button_cancel",
    "category": "Global",
    "action": "Onboarding",
    "name": "Browse Onboarding Tour"
  },
  {
    "id": "onboardingModal_click_button_iconButton",
    "category": "Global",
    "action": "Onboarding",
    "name": "Cancel Onboarding Tour"
  },
  {
    "id": "onboardingModal_click_button_submit",
    "category": "Global",
    "action": "Onboarding",
    "name": "Browse Onboarding Tour"
  },
  {
    "id": "snackbar_click_snackbar_reloadToGetUpdate",
    "category": "Global",
    "action": "Reload",
    "name": "Reload to get Update"
  },
  {
    "id": "comment_click_iconButton_submitAnswer",
    "category": "Messenger",
    "action": "Answer Comment",
    "name": "Submit Answer"
  },
  {
    "id": "comment_click_textButton_answerMessage",
    "category": "Messenger",
    "action": "Answer Comment",
    "name": "Answer Message"
  },
  {
    "id": "comment_click_textButton_closeAnswerMessage",
    "category": "Messenger",
    "action": "Answer Comment",
    "name": "Close Answer Message"
  },
  {
    "id": "enquiry_click_iconButton_answerMessage",
    "category": "Messenger",
    "action": "Answer Enquiry",
    "name": "Answer Message"
  },
  {
    "id": "comment_click_teaser_teaserLink",
    "category": "Messenger",
    "action": "Navigate",
    "name": "Open Conversation Item"
  },
  {
    "id": "comment_click_textButton_valueUnitLink",
    "category": "Messenger",
    "action": "Navigate",
    "name": "Open Value Unit Link"
  },
  {
    "id": "enquiry_click_teaser_teaserLink",
    "category": "Messenger",
    "action": "Navigate",
    "name": "Open Conversation Item"
  },
  {
    "id": "messengerNavigation_click_textButton_navLink",
    "category": "Messenger",
    "action": "Navigate",
    "name": "Open Messenger-Navigation-Link"
  },
  {
    "id": "messengerNavigation_click_button_action",
    "category": "Messenger",
    "action": "New Enquiry",
    "name": "Start"
  },
  {
    "id": "enquiry_click_iconButton_submitInitialMessage",
    "category": "Messenger",
    "action": "Submit Enquiry",
    "name": "Submit initial Message"
  },
  {
    "id": "generalSettings_click_listItem_changeLanguage",
    "category": "Settings Page",
    "action": "Change Language",
    "name": "Change Language"
  },
  {
    "id": "moreSettings_click_textButton_manageIDData",
    "category": "Settings Page",
    "action": "Manage dpa-ID Data",
    "name": "Manage dpa-ID Data"
  },
  {
    "id": "notifications_click_toggleButton_notifyByEMail",
    "category": "Settings Page",
    "action": "Manage Notifications",
    "name": "Notify by E-Mail"
  },
  {
    "id": "notifications_click_toggleButton_notifyByIDApp",
    "category": "Settings Page",
    "action": "Manage Notifications",
    "name": "Notify by ID-App"
  },
  {
    "id": "generalSettings_click_listItem_preferredCvDPage",
    "category": "Settings Page",
    "action": "Preferred CvD-Page",
    "name": "Select Preferred CvD Page"
  },
  {
    "id": "generalSettings_click_listItem_preferredHomepage",
    "category": "Settings Page",
    "action": "Preferred Homepage",
    "name": "Select Preferred Homepage"
  },
  {
    "id": "profileList_click_iconButton_delete",
    "category": "Profiles",
    "action": "Delete Profile",
    "name": "Intent To Delete Profile"
  },
  {
    "id": "deleteProfile:modal_click_button_delete_cancel",
    "category": "Profiles",
    "action": "Delete Profile",
    "name": "Quit Modal"
  },
  {
    "id": "deleteProfile:modal_click_button_delete_submit",
    "category": "Profiles",
    "action": "Delete Profile",
    "name": "Apply"
  },
  {
    "id": "profileList_click_iconButton_edit",
    "category": "Profiles",
    "action": "Edit Profile",
    "name": "Apply"
  },
  {
    "id": "editProfile:modal_click_button_edit_submit",
    "category": "Profiles",
    "action": "Edit Profile",
    "name": "Apply"
  },
  {
    "id": "editProfile:modal_click_button_edit_cancel",
    "category": "Profiles",
    "action": "Edit Profile",
    "name": "Apply"
  },
  {
    "id": "profileGenerator_click_button_save_profil",
    "category": "Profiles",
    "action": "Save Profile",
    "name": "Apply"
  },
  {
    "id": "saveProfile:modal_click_button_submit",
    "category": "Profiles",
    "action": "Save Profile",
    "name": "Apply"
  },
  {
    "id": "saveProfile:modal_click_button_cancel",
    "category": "Profiles",
    "action": "Save Profile",
    "name": "Quit Modal"
  },
  {
    "id": "saveProfile:modal_click_iconButton-clickaway-escape_close",
    "category": "Profiles",
    "action": "Save Profile",
    "name": "Quit Modal"
  },
  {
    "id": "accuracySlider_click_slider_adapt_accuracy",
    "category": "Profiles",
    "action": "Adapt Accuracy",
    "name": "Adapt Accuracy"
  },
  {
    "id": "searchInput_click_iconButton_search",
    "category": "Profiles",
    "action": "Search",
    "name": "Submit Search"
  },
  {
    "id": "backToProfileList_click_textButton_backToList",
    "category": "Profiles",
    "action": "Navigate",
    "name": "Back to List"
  }
]
